import { useTranslation } from 'react-i18next';
import { withStyles, Card, BodyText, Icon } from 'vopay';
import { Title, Button } from 'UI';
import type { OpenDialogProps } from '@/providers/Dialog.provider';
import successWarningIcon from './SuccessWarningIcon.svg';
import styles from './AccountCreatedWithErrorsDialog.module.scss';

const cn = withStyles(styles);

export type AccountCreatedWithErrorsResult = 'goToAccount' | 'fixLater';

type AccountCreatedWithErrorsDialogProps = OpenDialogProps<AccountCreatedWithErrorsResult> & {
  issues: string[];
};

export default function AccountCreatedWithErrorsDialog({ onConfirm, issues }: AccountCreatedWithErrorsDialogProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'R1AccountCreation.AccountCreatedWithErrors' });

  return (
    <Card hoverEffect={false} className={cn('dialog')}>
      <div className={cn('header')}>
        <img
          className={cn('icon')}
          src={successWarningIcon}
          alt={t('iconAlt', { defaultValue: 'Account created with warnings' })}
        />
        <div className={cn('headingBody')}>
          <Title level="3">{t('title', { defaultValue: 'Account Created — Errors Need Your Attention' })}</Title>
          <BodyText className={cn('greyText')}>
            {t('description', {
              defaultValue: "Your account has been created, but we found a few issues you'll need to address.",
            })}
          </BodyText>
        </div>
      </div>

      <div className={cn('errors')}>
        {issues.map((issue, index) => (
          <div key={`${index}-${issue}`} className={cn('errorRow')}>
            <Icon className={cn('errorIcon')} icon="cautionary2" size="sm" width="24px" height="24px" color="none" />
            <BodyText>{issue}</BodyText>
          </div>
        ))}
      </div>

      <div className={cn('buttons')}>
        <Button colorScheme="secondary" size="small" onClick={() => onConfirm('fixLater')}>
          {t('fixLater', { defaultValue: 'Fix Later' })}
        </Button>
        <Button colorScheme="primary" size="small" onClick={() => onConfirm('goToAccount')}>
          {t('goToAccount', { defaultValue: 'Go to Account' })}
        </Button>
      </div>
    </Card>
  );
}
